// extracted by mini-css-extract-plugin
module.exports =  {"icon":"fp0nADoeZp4NmR6M7DlJ"};